export enum ActionType {
  START_CALL = 'start_call',
  DECLINE = 'decline',
  WRITE_REPORT = 'write_report',
  DELETE = 'delete',
  ACCEPT = 'accept'
}
